import LabServiceCollection from "@/collections/LabServiceCollection";
import SubmissionStatusLogModel from "../../models/lab/SubmissionStatusLogModel";

/**
 * SubmissionStatusLog collection
 */
export default class SubmissionStatusLogCollection extends LabServiceCollection {

  // Model that is contained in this collection.
  model() {
    return SubmissionStatusLogModel;
  }

  /**
   * default collection configuration.
   */
  prepareFilter(CollectionFilter) {
    CollectionFilter.sortAddDesc('created_at');
    return CollectionFilter;
  }

}
